import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '@/components/Layout';
import WhoWeArePage from '@/components/who-we-are/WhoWeArePage';

const WhoWeAre = () => {
  return (
    <>
      <Helmet>
        <title>EPC Builder</title>
        <meta
          name="description"
          content="Improving your property's value, efficiency, and running costs with home upgrades"
        />
      </Helmet>
      <Layout title="EPC Builder Who We Are">
        <WhoWeArePage />
      </Layout>
    </>
  );
};

export default WhoWeAre;
